import { fotoDe, nombreDeTipo, partesDe } from "../../shared/dibujosHerramienta";

/* La herramienta en el tablero.
 *
 * ── SE DIBUJA IGUAL ESTÉ O NO ESTÉ ──────────────────────────────────────────
 *
 * Hasta el 14/09 la prestada se aplastaba a un tono: el hueco en la pared. Esa
 * idea supone UN tablero físico con UNA herramienta por gancho, y el taller no
 * es así. Igna: *«no hay 1 de cada cosa, por lo que que se ponga en gris no
 * tiene sentido»*.
 *
 * Con tres llaves combinadas, apagar «la» posición cuando una de las tres
 * salió dice algo falso: la llave está, hay dos más. Y al revés, dejarla
 * encendida cuando salieron las tres también. El estado real no lo puede
 * contar una silueta.
 *
 * Lo que sí lo cuenta es la chapa: *«pero sí la etiqueta de quién lo tiene y
 * hace cuánto y desde cuándo»*. Eso es un dato y no una metáfora.
 *
 * ── FOTO SI HAY, DIBUJO SI NO ───────────────────────────────────────────────
 *
 * El catálogo tiene 27 tipos fotografiados; el único sin foto es `generica`,
 * que es el dibujo que le toca a un tipo que no está en el catálogo. Un lugar
 * vacío en la pared se lee como «acá no falta nada», que es lo contrario de lo
 * que pasa.
 *
 * ── LOS COLORES NO SIGUEN AL TEMA ───────────────────────────────────────────
 *
 * El tablero es una pared de madera en tema claro y en oscuro: es un objeto del
 * taller, no una superficie de la aplicación. Un martillo se ve igual en los
 * dos.
 *
 * ── SIN TEXTO ADENTRO ───────────────────────────────────────────────────────
 *
 * El nombre va en la chapa de abajo. En la pared real la etiqueta está debajo
 * del gancho, y un nombre escrito encima tapa justo lo que hay que reconocer.
 */

const COLOR = {
  metal: "#c3cad3",
  metal_oscuro: "#7f8896",
  mango: "#d2443c",
  mango_2: "#2c313a",
  cuerpo: "#2c313a",
  acento: "#eeb01f",
  vidrio: "#7fc99a",
};

export default function DibujoHerramienta({ tipo, className }) {
  const foto = fotoDe(tipo);

  if (foto) {
    return (
      <img
        src={foto}
        alt=""
        aria-hidden="true"
        draggable="false"
        className={className}
        data-tipo={tipo || "generica"}
      />
    );
  }

  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-hidden="true"
      focusable="false"
      data-tipo={tipo || "generica"}
      data-sinfoto="1"
      preserveAspectRatio="xMidYMid meet"
    >
      <title>{nombreDeTipo(tipo)}</title>
      {partesDe(tipo).map((p, i) => (
        <path
          key={i}
          d={p.d}
          fill={COLOR[p.c] || COLOR.metal}
          fillRule="evenodd"
        />
      ))}
    </svg>
  );
}

export { COLOR };
